import { useEffect, useState } from "react";
import { FormProvider } from "../../../../../../common/provider/form/Form.provider";
import { CustomButton } from "../../../../../../common/components/CustomButton/CustomButton";
import { Form, Input, TimePicker } from "antd";
import style from "./style.module.scss";
import { SimpleInput } from "../../../../../../common/components/simpleInput";
import { WaitingTimeService } from "../../../../core/_request";
import { HttpStatusCode } from "axios";
import { Loader } from "../../../../../../common/components/Loader/Loader";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import TextArea from "antd/es/input/TextArea";
dayjs.extend(customParseFormat);

type WaitingTimeFormType = {
  onFinish: () => void;
  initialValue?: any;
};

export const WaitingTimeForm = ({
  onFinish,
  initialValue,
}: WaitingTimeFormType) => {
  const [form] = Form.useForm();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);

  useEffect(() => {
    if (initialValue) {
      form.setFieldsValue({
        ...initialValue,
        // startAt: dayjs(initialValue.startAt, "DD/MM/YYYY HH:mm:ss"),
        startAt: initialValue?.startAt ? dayjs(initialValue.startAt, "YYYY-MM-DD HH:mm") : dayjs(initialValue.createdAt, "DD/MM/YYYY HH:mm:ss").startOf("day"),
        endAt: initialValue?.endAt ? dayjs(initialValue.endAt, "YYYY-MM-DD HH:mm") : dayjs(initialValue.createdAt, "DD/MM/YYYY HH:mm:ss").startOf("day"),
      });

    }
  }, [initialValue]);

  const onSubmitHandler = async (values: any) => {
    try {
      setIsLoadingSubmit(true);
      const dataToPost = {
        ...values,
        ...(initialValue
          ? {
              "@id": initialValue?.["@id"],
            }
          : {}),
        endAt: dayjs(initialValue?.startAt, "DD/MM/YYYY HH:mm:ss")
          .set("hour", values?.endAt.hour())
          .set("minute", values?.endAt.minute())
          .set("second", 0)
          .format("YYYY-MM-DD HH:mm"),
        startAt: dayjs(initialValue?.startAt, "DD/MM/YYYY HH:mm:ss")
          .set("hour", values?.startAt.hour())
          .set("minute", values?.startAt.minute())
          .set("second", 0)
          .format("YYYY-MM-DD HH:mm"),
      };

      if (dataToPost?.id) {
        const res = await WaitingTimeService.updateWaitingTime(
          dataToPost
        );
        if (
          res?.status === HttpStatusCode.Ok
        ) {
          onFinish();
          form.resetFields();
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  return (
    <div>
      <FormProvider
        Form={Form}
        form={form}
        debug={true}
        onFinish={(values: any) => {
          onSubmitHandler(values);
        }}
        onFinishFailed={(err) => {
          console.log("err", err);
        }}
      >
        <Loader isLoading={isLoading} />
        <div className="d-none">
          <SimpleInput
            Form={Form}
            label="ID"
            name={"id"}
            customInput={<Input />}
          />
        </div>
        <div className={style.form}>
          <div className={style.form__item_wrapper}>
            {/* Ligne 2 */}
            <div className={style.form__row}>
              <div className={style.form__col}>
                <SimpleInput
                  Form={Form}
                  label="Motif"
                  name="reason"
                  customInput={<TextArea
                    //value={}
                    //onChange={(e) => setValue(e.target.value)}
                    placeholder="Insert text"
                    autoSize={{ minRows: 3, maxRows: 5 }}
                  />}
                />
              </div>
              {/* <div className={style.form__col}></div> */}
            </div>

            {/* Ligne 1 */}
            <div className={style.form__row}>
            <div className={`${style.form__col} ${style.form__time_picker}`}>
                <SimpleInput
                  Form={Form}
                  label="Heure de début"
                  name={"startAt"}
                  rules={[
                    {
                      required: true,
                      message: `Ce champ est requis`,
                    },
                  ]}
                  customInput={
                    <TimePicker
                      style={{ width: "100%" }}
                      needConfirm={false}
                      format={"HH:mm"}
                      showNow={false}
                    />
                  }
                />
              </div>
              <div className={`${style.form__col} ${style.form__time_picker}`}>
                <SimpleInput
                  Form={Form}
                  label="Heure de fin"
                  name={"endAt"}
                  rules={[
                    {
                      required: true,
                      message: `Ce champ est requis`,
                    },
                  ]}
                  customInput={
                    <TimePicker
                      style={{ width: "100%" }}
                      needConfirm={false}
                      format={"HH:mm"}
                      showNow={false}
                    />
                  }
                />
              </div>
            </div>
          </div>
        </div>

        <div className={style.form__action_wrapper}>
          <CustomButton
            type="submit"
            className={style.form__action_button}
            isLoading={isLoadingSubmit}
          >
            Enregistrer
          </CustomButton>
        </div>
      </FormProvider>
    </div>
  );
};
